import React from "react";
import "./Footer.css";

const Footer: React.FC = () => (
  <footer className="footer">
    <div className="footer-container">
      <div className="footer-content">
        <div className="footer-brand">
          <div className="footer-logo">ARQITE</div>
          <p className="footer-tagline">Field operations software for snagging, ownership, and handover reporting.</p>
        </div>
        
        <div className="footer-links">
          <div className="footer-section">
            <h4>Product</h4>
            <a href="#features">Product</a>
            <a href="#workflow">Workflow</a>
            <a href="#reporting">Reporting</a>
          </div>
          
          <div className="footer-section">
            <h4>Company</h4>
            <a href="#home">Arqite</a>
            <a href="#contact">Contact</a>
            <a href="https://app.arqite.com" target="_blank" rel="noopener noreferrer">Start Free</a>
          </div>
          
          <div className="footer-section">
            <h4>Support</h4>
            <a href="mailto:support@arqite.com">Help Center</a>
            <a href="mailto:sales@arqite.com">Book a Demo</a>
            <a href="#contact">Get in touch</a>
          </div>
        </div>
      </div>
      
      <div className="footer-bottom">
        <div className="footer-copyright">
          <span>&copy; {new Date().getFullYear()} Arqite. All rights reserved.</span>
        </div>
        <div className="footer-badges">
          <div className="made-in-ireland-badge">Made in Ireland</div>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
